import type {
	CustomEntityTransform,
	DraftEntity,
} from '../../../../shared/components/rich-text-editor-draftjs-wrapper/DraftJsToHtmlConverter';

/**
 * Entity → HTML transform for the ticketing surfaces, supplied to the shared
 * draft-js converter's `customEntityTransform` seam (ACC-515).
 *
 * - MENTION: ticketing creates `MENTION` entities as `{userId, name}` (see insertMention.ts),
 *   which have no `data.mention` object. The shared default branch expects `data.mention.personId`,
 *   so we must handle MENTION here. We render the entity's plain text (the name) to match the
 *   prior `draft-js-export-html` output exactly.
 * - MERGE_TAG: auto-reply templates store `{token, label}`; the backend expects the `[token]`
 *   bracket syntax. This replaces the manual ContentState pre-processing the util used to do.
 */
export const ticketingEntityTransform: CustomEntityTransform = (entity: DraftEntity, text: string) => {
	const type = entity?.type?.toUpperCase();
	if (type === 'MENTION') {
		return text;
	}
	if (type === 'MERGE_TAG') {
		const token = (entity.data as {token?: string}).token;
		return `[${token}]`;
	}
	return undefined;
};
